import axios from 'axios';
import the from '../objects/the';
import use from '../objects/use';

export default function useUpdateAccountApi() {
   const tracker = use.inflightTracker;
   
   const updateAccount = (temporaryUsername = '', temporaryPassword = '', updates = [], headers, callBack = the.emptyFunction) => {
      const url = '/update-account';
      if (tracker.isAlreadyInflight(url))
         return;
      tracker.addApiCall(url);
      axios.post(
         process.env.REACT_APP_API_ENDPOINT + url,
         {
            username: temporaryUsername,
            password: temporaryPassword,
            updates
         },
         headers
      ).then(response => {
         tracker.removeApiCall(url);
         callBack({code: 204, ...response});
      }).catch(error => {
         tracker.removeApiCall(url);
         if (error?.response?.data) {
            callBack({code: error.response.data.code, errors: error.response.data.errors});
         } else {
            callBack();
         }
      });
   };
   
   return {
      updateAccount,
   };
}